<template lang="pug">
    v-col(cols='12' md='12')
        v-alert(
            border="left"
            colored-border
            elevation="2"
            :color="validUnrespondedToIncomingMessage ? 'red lighten-2' : 'green lighten-2'"
            style="padding-top: 0; padding-bottom: 0; margin-bottom: 8px;"
        )
            v-container
                v-row(align='center')
                    v-col.grow
                        .div(v-if="validUnrespondedToIncomingMessage")
                            RunningClock(
                                before-text="Longest Waiting:"
                                :timestamp="oldestUnrespondedToIncomingMessageAt"
                            )
                        .div(v-else)
                            | 0 awaiting response
                    v-col.shrink
                        v-bottom-sheet(v-model='sheet' scrollable)
                            template(v-slot:activator='{ on }')
                                v-btn(color='var(--volie-gray)' dark v-on='on' fab x-small ripple)
                                    v-icon mdi-format-list-bulleted-square

                            v-card(outlined tile style="max-height: 350px; overflow-y: auto;")
                                v-list
                                    v-subheader.dense-subheader
                                        .text-subtitle-2 Assigned customers
                                    v-subheader.dense-subheader
                                        .caption Click on a row to switch between conversations
                                    template(
                                        v-for='cc in campaignCustomers'
                                    )
                                        v-list-item(
                                            :key='cc.campaign_customer_id'
                                            @click='sheet = false; changeCampaignCustomers(cc);'
                                            :disabled="cc.status === 'in_progress'"
                                            ripple
                                        )
                                            v-list-item-avatar
                                                v-avatar(size='32px' tile)
                                                    v-icon(v-bind:class="{'red--text': hasUnrespondedToIncomingMessage(cc.conversation_group)}") mdi-account

                                            v-list-item-content
                                                v-list-item-title {{ cc.customer.full_name }}
                                                v-list-item-subtitle {{ cc.organization_name }}: {{ cc.campaign_name }}

                                            v-list-item-icon.list-item-icon-margin-override(v-if="cc.conversation_group && cc.conversation_group.conversation_group_id > 0")
                                                v-simple-table(style="min-width: 500px;")
                                                    template(v-slot:default)
                                                        tbody
                                                            tr
                                                                td.text-left(style="width: 45%; max-width: 45%;")
                                                                    .red--text(v-if="hasUnrespondedToIncomingMessage(cc.conversation_group)")
                                                                        RunningClock(
                                                                            before-text="Waiting "
                                                                            :timestamp="cc.conversation_group.unresponded_to_incoming_message_at"
                                                                        )
                                                                    .div(v-else) {{ lastMessageTime(cc.conversation_group) }}
                                                                td.text-right(style="width: 45%; max-width: 45%;")
                                                                    .div(v-if="cc.status === 'in_progress'")
                                                                        .text-green.font-weight-bold.display-inline ACTIVE
                                                                    .div(v-else)
                                                                        .red--text(v-if="conversationGroupTotalUnreadMessages(cc.conversation_group) > 0")
                                                                            <strong>{{ conversationGroupTotalUnreadMessages(cc.conversation_group) | number }} </strong> unread messages
                                                                        .div(v-else)
                                                                            <strong>0 </strong> unread messages
                                                                td.text-right(style="width: 10%; max-width: 10%;")
                                                                    .div(v-if="cc.status === 'in_progress'")
                                                                        v-icon(color="green") mdi-cellphone
                                                                    .div(v-else)
                                                                        v-icon(color="error" v-if="hasUnrespondedToIncomingMessage(cc.conversation_group)") mdi-message-alert
                                                                        v-icon(v-else) mdi-message-outline
                                                            tr
                                                                td(colspan="3")
                                                                    .message-body-table-cell {{ cc.conversation_group.last_message_body }}

                                        v-divider

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import RunningClock from '@/components/shared/running_clock.vue';

    export default Vue.extend({
        data() {
            return {
                sheet: false,
            }
        },
        methods: {
            conversationGroupTotalUnreadMessages(conversationGroup) {
                return (conversationGroup?.unread_message_ids || []).length;
            },
            hasUnrespondedToIncomingMessage(conversationGroup) {
                return conversationGroup?.unresponded_to_incoming_message_id > 0;
            },
            lastMessageTime(conversationGroup) {
                const messageTime = conversationGroup?.last_message_time;
                if (!!messageTime && messageTime.length > 0) {
                    const d = new Date(messageTime);
                    return d.toLocaleString();
                }

                return;
            },
        },
        computed: {
            assignedTotalUnreadMessages() {

                // Init
                let total = 0;

                // Verify that we have valid campaign customers
                if (!(!!this.campaignCustomers && this.campaignCustomers.length > 0)) {
                    return total;
                }

                for (let i = 0; i < this.campaignCustomers.length; i++) {
                    const campaignCustomer = this.campaignCustomers[i];
                    total = total + this.conversationGroupTotalUnreadMessages(campaignCustomer?.conversation_group);
                }

                return total;
            },
            oldestUnrespondedToIncomingMessageAt() {

                // Verify that we have valid campaign customers
                if (!(!!this.campaignCustomers && this.campaignCustomers.length > 0)) {
                    return null;
                }

                // Init
                let oldestAt = null;
                let oldestID = null;

                // Loop through records and find the longest waiting time if applicable
                for (let i = 0; i < this.campaignCustomers.length; i++) {
                    const campaignCustomer = this.campaignCustomers[i];

                    // Verify campaign customer has valid unresponded to incoming message
                    if (!(campaignCustomer?.conversation_group?.unresponded_to_incoming_message_id > 0 && !!campaignCustomer?.conversation_group?.unresponded_to_incoming_message_at)) {
                        continue;
                    }

                    // If the oldest is null or the current is less than the oldest
                    if (oldestID === null || campaignCustomer?.conversation_group?.unresponded_to_incoming_message_id < oldestID) {

                        // Set mins
                        oldestAt = campaignCustomer?.conversation_group?.unresponded_to_incoming_message_at;
                        oldestID = campaignCustomer?.conversation_group?.unresponded_to_incoming_message_id;
                    }
                }

                return oldestAt;
            },
            totalAssignedUnrespondedToCustomers() {

                // Init
                let totalCustomers = 0;

                // Verify that we have valid campaign customers
                if (!(!!this.campaignCustomers && this.campaignCustomers.length > 0)) {
                    return totalCustomers;
                }

                // Loop through records and find the longest waiting time if applicable
                for (let i = 0; i < this.campaignCustomers.length; i++) {
                    const campaignCustomer = this.campaignCustomers[i];

                    // Verify campaign customer has valid unresponded to incoming message
                    if (!(campaignCustomer?.conversation_group?.unresponded_to_incoming_message_id > 0 && !!campaignCustomer?.conversation_group?.unresponded_to_incoming_message_at)) {
                        continue;
                    }

                    // Increase by 1
                    totalCustomers++;
                }

                return totalCustomers;
            },
            validUnrespondedToIncomingMessage() {
                const oldest = this.oldestUnrespondedToIncomingMessageAt;
                return oldest?.length > 0;
            },
        },
        components: {
            RunningClock,
        },
        props: {
            campaignCustomers: Array,
            changeCampaignCustomers: Function,
            setSmsMessageTotalAssignedUnrespondedToCustomers: Function,
        },
        watch: {
            totalAssignedUnrespondedToCustomers() {
                this.setSmsMessageTotalAssignedUnrespondedToCustomers(this.totalAssignedUnrespondedToCustomers);
            },
        },
        created() {
            this.setSmsMessageTotalAssignedUnrespondedToCustomers(this.totalAssignedUnrespondedToCustomers);
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .message-body-table-cell {
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 500px;
            display: block;
            overflow: hidden;
            padding: 0px 2px 0px 2px;
        }

        .list-item-icon-margin-override {
            margin: 8px 0 8px 16px;
        }

        .dense-subheader {
            height: 24px;
        }
    }
</style>
